// extracted by mini-css-extract-plugin
export default {"seriesDetailNav":"orTall1MK0PTJVHCa9qj","seriesMiniDetailNav":"d4xSkvgm9HQXr_fIQxbV","link":"ZfAdE9o8ihuXUt3951cs","navSection":"CEkDCqp_PoSeZd49mc3K"};